import ZigzagGuideImg1 from '@/assets/images/zigzag-guide-img-1.png';
import ZigzagGuideImg2 from '@/assets/images/zigzag-guide-img-2.png';
import ZigzagGuideImg3 from '@/assets/images/zigzag-guide-img-3.png';
import ZigzagGuideImg4 from '@/assets/images/zigzag-guide-img-4.png';
import { Card } from '@/components/atoms/Card';

export const ZigzagGuideImgCard = () => {
  return (
    <Card className="space-y-[30px] p-[30px]">
      {GuideItems.map((item) => (
        <div className="space-y-5">
          <div className="space-y-2">
            <div className="flex gap-1.5">
              <Badge label={item.number} />
              <div className="mt-px">{item.title}</div>
            </div>
            {item.desc && <div className="pl-7 Body5M14">{item.desc}</div>}
          </div>
          {item.image && (
            <div className="flex justify-center px-[30px]">
              <img src={item.image} className="w-full" />
            </div>
          )}
        </div>
      ))}
    </Card>
  );
};

const Badge = ({ label }: { label: number }) => {
  return (
    <span className=" flex h-[22px] w-[22px] items-center justify-center rounded-[4px]  bg-blue-400 text-[12px] font-bold leading-[18px] text-white">
      {label}
    </span>
  );
};

const GuideItems = [
  {
    number: 1,
    title: (
      <>
        <span className="font-bold">지그재그 파트너센터</span> 로그인
      </>
    ),
    image: ZigzagGuideImg1,
  },
  {
    number: 2,
    title: (
      <>
        좌측 하단{' '}
        <span className="font-bold">
          내 스토어 정보 관리
          {' >'} API 인증키 관리 클릭
        </span>{' '}
        클릭
      </>
    ),
    image: ZigzagGuideImg2,
  },
  {
    number: 3,
    title: (
      <>
        <span className="font-bold">API 인증키 발급</span> 버튼 클릭
      </>
    ),
    image: ZigzagGuideImg3,
  },
  {
    number: 4,
    title: <span className="Body1S16">Access Key와 Secret Key 복사</span>,
    desc: (
      <>
        인증키 발급 완료 팝업창을 닫으면 Secret Key를 다시 확인할 수 없어요.
        <br />
        Secret Key는 반드시 복사하여 별도 공간에 저장해 둔 상태로 진행해 주세요.
        <br />
        복사한 API 인증키는 셀러박스 화면 상단 API 입력칸에 붙여넣기 해주세요.
      </>
    ),
    image: ZigzagGuideImg4,
  },
];
